export const analyticalDatasetKeys = {
  all: ['analytical-datasets'] as const,
  lists: () => [...analyticalDatasetKeys.all, 'list'] as const,
  list: (projectId: string) => [...analyticalDatasetKeys.lists(), projectId] as const,
  details: () => [...analyticalDatasetKeys.all, 'detail'] as const,
  detail: (profileId: string) => [...analyticalDatasetKeys.details(), profileId] as const,
  profiles: () => [...analyticalDatasetKeys.all, 'profile'] as const,
  profile: (profileId: string) => [...analyticalDatasetKeys.profiles(), profileId] as const,
  versions: () => [...analyticalDatasetKeys.all, 'version'] as const,
  version: (versionId: string) => [...analyticalDatasetKeys.versions(), versionId] as const,
  results: () => [...analyticalDatasetKeys.all, 'results'] as const,
  profileResults: (profileId: string) => [...analyticalDatasetKeys.results(), profileId] as const,
  resultsPage: (profileId: string, searchParams: string) =>
    [...analyticalDatasetKeys.profileResults(profileId), searchParams] as const,
};
